import React from 'react';
import {
  getProjectType,
  hasValue,
  ProjectTypes,
} from '@r-and-a-shared-ui/utils';
import { FormCTA, FormCTAProps } from '../FormCTA/FormCTA';
import stylesSSO from './scss/FormHeaderSSO.module.scss';
import stylesPP from './scss/FormHeaderPP.module.scss';
import { RichTextParser } from '@r-and-a-shared-ui/common-ui';
import Image from 'next/image';

export interface FormHeaderProps {
  headerTitle?: string;
  headerSubTitle?: string;
  titleColor?: string;
  subTitleColor?: string;
  headerCTAs?: FormCTAProps[];
  isMembership?: boolean;
  logo?: {
    url: string;
    alt: string;
    width: number;
    height: number;
  };
}

export function FormHeader(props: FormHeaderProps) {
  const {
    headerTitle,
    headerSubTitle,
    titleColor,
    subTitleColor,
    headerCTAs,
    isMembership,
    logo,
  } = props;

  const projectType = getProjectType();
  const styles =
    projectType === ProjectTypes.PlayerPortals ? stylesPP : stylesSSO;

  const renderFormHeaderCTAs = (
    ctasProps: FormCTAProps[] | undefined,
  ): React.JSX.Element | undefined => {
    if (!hasValue(ctasProps) || typeof ctasProps === 'undefined') {
      return undefined;
    }
    return (
      <div className={`${styles['form__header-buttons']}`}>
        {ctasProps.map(ctasProps => {
          return (
            <FormCTA
              {...ctasProps}
              key={ctasProps?.key}
              isMembership={isMembership}
            />
          );
        })}
      </div>
    );
  };

  const removeHTMLtag = (content: string | undefined): boolean => {
    if (!content) return false;
    const strippedContent = content.replace(/(<([^>]+)>)/gi, '').trim();
    return strippedContent.length > 0;
  };

  return (
    <div
      className={`${styles['form__header']} ${
        isMembership ? styles['form__header-membership'] : ''
      }`}
    >
      <div className={styles['form__header-content']}>
        {isMembership ? (
          <>
            {headerTitle && (
              <div
                role="heading"
                aria-level={2}
                className={styles['form__header-subtitle']}
              >
                <span style={{ color: titleColor }}>{headerTitle}</span>
              </div>
            )}
            {removeHTMLtag(headerSubTitle) && (
              <div
                role="heading"
                aria-level={3}
                className={styles['form__header-title']}
                style={{ color: subTitleColor }}
              >
                <RichTextParser richText={headerSubTitle} />
              </div>
            )}
          </>
        ) : (
          <>
            {logo?.url && (
              <div>
                <Image
                  src={logo?.url}
                  alt={logo?.alt || 'One Club Logo'}
                  width={logo?.width || 120}
                  height={logo?.height || 60}
                />
              </div>
            )}
            <div
              role="heading"
              aria-level={2}
              className={styles['form__header-subtitle']}
            >
              <span style={{ color: titleColor }}>{headerTitle}</span>
            </div>
            {removeHTMLtag(headerSubTitle) && (
              <div
                role="heading"
                aria-level={3}
                className={styles['form__header-title']}
                style={{ color: subTitleColor }}
              >
                <RichTextParser richText={headerSubTitle} />
              </div>
            )}
          </>
        )}
      </div>
      {renderFormHeaderCTAs(headerCTAs)}
    </div>
  );
}

export default FormHeader;
